import React, { Fragment } from 'react'
import styled from '@emotion/styled'

import InfoSteps from './steps/TellUsAboutYourCar'

import { grayLight30, fontSizeXLarge, fontSizeSmall, fontSizeMedium, fontSize2XSmall, fontSize3XSmall } from '../../constants/principles'
import { FlexRowDiv } from '../generic/Basics'
import { breakpoints } from '../../constants'
import LandingVideo from './LandingVideo'

export default ({
  isAssigned,
  dealerName,
  dealerIsDirectToKBB,
  dealerIsDirectToKBBv2,
  howItWorksStyleChanged,
  videoEnabled,
  howItWorksTitleCopy,
  howItWorksSubtitleCopy,
  easyWayCopy,
  videoUrl,
  videoThumbnailUrl,
  infoSteps,
  globalState,
  updateGlobalState
}) => {
  const steps = InfoSteps({
    dealerIsDirectToKBB,
    dealerIsDirectToKBBv2,
    infoSteps
  })

  const Heading = () => {
    if (howItWorksTitleCopy) {
      return howItWorksTitleCopy
    } else if (dealerIsDirectToKBB || dealerIsDirectToKBBv2) {
      return 'How It Works'
    }
    return 'How does Instant Cash Offer work?'
  }

  return (
    <StyledSection {...{ howItWorksStyleChanged }}>
      <StyledH2>
        <Heading />
      </StyledH2>
      {howItWorksSubtitleCopy && <StyledH3>{howItWorksSubtitleCopy}</StyledH3>}
      {videoEnabled && <LandingVideo url={videoUrl} thumbnailUrl={videoThumbnailUrl} {...{ globalState, updateGlobalState }} />}
      {easyWayCopy && <EasyWayHeading>{easyWayCopy}</EasyWayHeading>}

      {steps.map((step, index) => (
        <Fragment key={index}>
          <StyledFlexDiv key={index} reverse={dealerIsDirectToKBB || dealerIsDirectToKBBv2 || index % 2 === 1}>
            <StyledImg src={step.image} alt={step.text} reverse={dealerIsDirectToKBB || dealerIsDirectToKBBv2 || index % 2 === 1} padding={step.padding} />
            <StyledDiv>
              <StyledH3>{isAssigned && step.id === 'Dealer' ? 'Bring Your Car to ' + dealerName : step.text}</StyledH3>
              <StyledH4>{step.subText}</StyledH4>
            </StyledDiv>
          </StyledFlexDiv>
          {index + 1 !== steps.length && <DividingLine />}
        </Fragment>
      ))}
    </StyledSection>
  )
}

const StyledDiv = styled.div`
  flex-grow: 1;
  width: 55%;
`

const StyledFlexDiv = styled(FlexRowDiv)`
  flex-direction: ${p => p.reverse && 'row-reverse'};
  width: 100%;
  justify-content: space-between;
`

const TestH2 = `
  font-weight: 800;
  font-size: 24px;
  line-height: 28px;
  color: #505050;
  font-family: Montserrat;
`
const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95%;

  @media (min-width: ${breakpoints.lg}px) {
    width: 65%;
  }

  max-width: 1024px;

  ${p =>
    p.howItWorksStyleChanged &&
    `
    > h2 {
      ${TestH2}
    }
    > h3 {
      font-size: 14px;
      font-weight: 500;
      margin: 0;
      font-family: Montserrat;
    }
  `}
`
const EasyWayHeading = styled.h2`
  ${TestH2}
  margin-top: 40px;
  text-align: center;
  padding: 0 10px;
`

const StyledH2 = styled.h2`
  font-size: ${fontSizeSmall};
  font-weight: inherit;
  line-height: 30px;
  @media (min-width: ${breakpoints.lg}px) {
    font-size: ${fontSizeXLarge};
    line-height: 40px;
    margin-bottom: 0;
  }
  text-align: center;
`

const StyledH3 = styled.h3`
  font-size: ${fontSize2XSmall};
  font-weight: inherit;
  margin: 8px 0px;
  line-height: 22px;

  font-size: ${fontSizeSmall};
  line-height: 22px;
  @media (min-width: ${breakpoints.lg}px) {
    font-size: ${fontSizeMedium};
    line-height: 30px;
  }
`

const StyledH4 = styled.h4`
  font-size: ${fontSize3XSmall};
  font-weight: inherit;
  line-height: 18px;

  @media (min-width: ${breakpoints.lg}px) {
    font-size: 18px;
    line-height: 24px;
  }

  margin: 8px 0px;
  font-weight: normal;
`

const StyledImg = styled.img`
  object-fit: contain;
  width: 80px;
  height: 80px;
  margin: 0px ${p => (!p.reverse ? 20 : 0)}px 0px ${p => (p.reverse ? 20 : 0)}px;
  @media (min-width: ${breakpoints.lg}px) {
    width: 220px;
    height: 220px;
    margin: 0px ${p => (!p.reverse ? 40 : 0)}px 0px ${p => (p.reverse ? 40 : 0)}px;
    ${p => p.padding && `padding: ${p.padding};`}
  }
`

const DividingLine = styled.div`
  border-bottom: 1px solid ${grayLight30};
  width: 100%;
`
